function openSizePopup() {

  var popup = document.getElementById("sizeChartPopup");
  popup.style.display = "flex";

  var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!mainForm) return;

  var mainVariantInput = mainForm.querySelector('input[name="id"]');
  if (!mainVariantInput) return;

  var currentVariantId = mainVariantInput.value;

  var popupRadios = popup.querySelectorAll('input[name="popup-variant"]');

  var matched = false;

  popupRadios.forEach(function(radio){

    if(radio.value === currentVariantId && !radio.disabled){
      radio.checked = true;
      matched = true;
    } else {
      radio.checked = false;
    }

  });

  /* If selected variant is sold out → auto select first available */
  if(!matched){
    var firstAvailable = popup.querySelector('input[name="popup-variant"]:not(:disabled)');
    if(firstAvailable){
      firstAvailable.checked = true;
    }
  }

  updateRowHighlight();
}


function closeSizePopup() {
  document.getElementById("sizeChartPopup").style.display = "none";
}


function updateRowHighlight(){

  var popup = document.getElementById("sizeChartPopup");
  if(!popup) return;

  var selectedRadio = popup.querySelector('input[name="popup-variant"]:checked');
  if(!selectedRadio) return;

  /* CO-ORD LOGIC */
  if(popup.querySelector(".top-row")){

    popup.querySelectorAll(".top-row, .bottom-row").forEach(function(row){
      row.classList.remove("active");
    });

    var selectedTopRow = selectedRadio.closest(".top-row");

    if(selectedTopRow){
      selectedTopRow.classList.add("active");

      var sizeValue = selectedTopRow.getAttribute("data-size");

      popup.querySelectorAll('.bottom-row').forEach(function(row){
        if(row.getAttribute("data-size") === sizeValue){
          row.classList.add("active");
        }
      });
    }

  }

  /* SINGLE PRODUCT LOGIC */
  else{

    popup.querySelectorAll(".size-row").forEach(function(row){
      row.classList.remove("active");
    });

    var selectedRow = selectedRadio.closest(".size-row");
    if(selectedRow){
      selectedRow.classList.add("active");
    }

  }

}


/* Row Click */
document.addEventListener("click", function(e){

  var row = e.target.closest("#sizeChartPopup .size-row");

  if (!row || row.classList.contains("sold-out")) return;

  var radio = row.querySelector('input[type="radio"]');

  if (radio && !radio.disabled) {
    radio.checked = true;
    updateRowHighlight();
  }

});


/* Radio Change */
document.addEventListener("change", function(e){
  if (e.target.name === "popup-variant") {
    updateRowHighlight();
  }
});


function addToCartFromPopup() {

  var selectedVariant = document.querySelector('#sizeChartPopup input[name="popup-variant"]:checked');

  if (!selectedVariant || selectedVariant.disabled) {
    alert("Please select available size");
    return;
  }

  var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!mainForm) return;

  var mainVariantInput = mainForm.querySelector('input[name="id"]');
  var mainAddButton = mainForm.querySelector('button[type="submit"]');

  if (!mainVariantInput || !mainAddButton) return;

  mainVariantInput.value = selectedVariant.value;
  mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));

  mainAddButton.click();
  closeSizePopup();
}


/* Ensure highlight correct on load */
document.addEventListener("DOMContentLoaded", function(){
  updateRowHighlight();
});






/* second-js */
document.addEventListener("DOMContentLoaded", function(){

  var disabledSizes = [];

  // Shopify default disabled sizes collect karo
  document.querySelectorAll('input[name="Size"].disabled').forEach(function(input){
    disabledSizes.push(input.value.trim());
  });

  // Top + Bottom dono rows target karo
  document.querySelectorAll(".top-row, .bottom-row").forEach(function(row){

    var popupSize = row.dataset.size ? row.dataset.size.trim() : "";

    if(disabledSizes.includes(popupSize)){

      // Sold out class add
      row.classList.add("sold-out");

      // Agar top row hai to radio bhi disable karo
      var radio = row.querySelector('input[type="radio"]');
      if(radio){
        radio.disabled = true;
        radio.checked = false;
      }

    }

  });

});






/* third-js */

document.addEventListener("DOMContentLoaded", function(){

  function updateSizeMeta(){

    var selectedSizeInput = document.querySelector('input[name="Size"]:checked');
    if(!selectedSizeInput) return;

    var selectedSize = selectedSizeInput.value.trim();

    var sizeInputs = document.querySelectorAll('input[name="Size"]');
    var index = 0;

    sizeInputs.forEach(function(input, i){
      if(input.value.trim() === selectedSize){
        index = i;
      }
    });

    var chestArr = window.productSizeMeta.chest ? window.productSizeMeta.chest.split(',') : [];
    var lengthArr = window.productSizeMeta.length ? window.productSizeMeta.length.split(',') : [];
    var waistArr = window.productSizeMeta.bottom_waist ? window.productSizeMeta.bottom_waist.split(',') : [];
    var bottomLengthArr = window.productSizeMeta.bottom_length ? window.productSizeMeta.bottom_length.split(',') : [];

    var html = "";

    if(chestArr[index]){
      html += "CHEST: " + chestArr[index] + "\" ";
    }

    if(lengthArr[index]){
      html += " &nbsp;&nbsp;|&nbsp;&nbsp;  LENGTH: " + lengthArr[index] + "\" ";
    }

    if(waistArr[index]){
      html += " &nbsp;&nbsp;|&nbsp;&nbsp;  WAIST: " + waistArr[index] + "\" ";
    }

    if(bottomLengthArr[index]){
      html += " &nbsp;&nbsp;|&nbsp;&nbsp;  BOTTOM LENGTH: " + bottomLengthArr[index] + "\" ";
    }

    document.getElementById("sizeMetaDisplay").innerHTML = html;
  }

  // Initial load
  updateSizeMeta();

  // On size change
  document.addEventListener("change", function(e){
    if(e.target.name === "Size"){
      updateSizeMeta();
    }
  });

});




